import Box from '@sendsprint/ui-react/dist/components/Box';
import Skeleton from '@sendsprint/ui-react/dist/components/Skeleton';
import SuspenseWrapper from '@src/components/suspenseWrapper';
import React, { lazy } from 'react';
import { UsePaymentLinkFormResponse } from '../../../hooks/usePaymentLinkForm';
import NoPrimaryAccount from '../noPrimaryAccount';
import PaymentLinkFormContent from '../paymentLinkFormContent';

const ErrorState = lazy(() => import('@src/components/errorState'));

interface Props {
  paymentLinkResponse: UsePaymentLinkFormResponse;
  variant?: 'receiver' | 'raas';
}

const SinglePaymentLinkFormInner = ({ paymentLinkResponse, variant }: Props) => {
  const {
    primarySettlementAccount,
    primarySettlementAccountError,
    primarySettlementAccountLoading,
    primarySettlementAccountRefetch
  } = paymentLinkResponse;

  const primaryAccountExist = !!primarySettlementAccount;

  return (
    <>
      {!primarySettlementAccountError && (
        <>
          {primarySettlementAccountLoading && (
            <Box className="ss-space-y-3">
              {[...Array(7)].map((_, index) => (
                <Skeleton key={index} className="ss-h-20 ss-rounded-lg" />
              ))}
            </Box>
          )}
          {!primarySettlementAccountLoading && primaryAccountExist && variant === 'receiver' && (
            <PaymentLinkFormContent paymentLinkResponse={paymentLinkResponse} />
          )}
          {variant === 'raas' && (
            <PaymentLinkFormContent paymentLinkResponse={paymentLinkResponse} />
          )}
          {!primarySettlementAccountLoading && !primaryAccountExist && variant === 'receiver' && (
            <NoPrimaryAccount />
          )}
        </>
      )}
      {primarySettlementAccountError && (
        <SuspenseWrapper returnNullErrorFallback>
          <ErrorState
            errorText="Error fetching neccessary information"
            retryFunc={primarySettlementAccountRefetch}
            showRetryBtn
          />
        </SuspenseWrapper>
      )}
    </>
  );
};

export default SinglePaymentLinkFormInner;
